import { PolizaEntity } from "../../../empresas/entities/polizas_cliente_entity";
import { ClienteLogin } from "../../../login/cliente_login";

export class VamTitularEntity {
    constructor(
        public CodigoTitular?: number,
        public Ciudad?: number,
        public Cedula?: string,
        public PrimerNombre?: string,
        public SegundoNombre?: string,
        public ApellidoPaterno?: string,
        public ApellidoMaterno?: string,
        public TelefonoPrincipal?: string,
        public TelefonoSecundario?: string,
        public Email1?: string,
        public Email2?: string,
        public FechaNacimiento?: Date,
        public Categoria?: string,
        public CodigoCategoria?: number,
        public Dependientes?: DependientesVam[],
        public BanderaExclusion?: boolean,
        public BanderaYaExcluido: boolean = false,
        public Poliza ?:PolizaEntity[],
        public NombreRepresentante?: string,
        public MailRepresentante?: string,
        public CelularRepresentante?: string,
        public CedulaRepresentante?: string,
        public fechaInclusion?: Date,
        public NombreCompletoTitular?: string,
        public uniCod?: number,
    ) { }
}

export class DependientesVam {
    constructor(
        public CodigoTitular?: number,
        public CodigoDependiente?: number,
        public PrimerNombre?: string,
        public SegundoNombre?: string,
        public ApellidoPaterno?: string,
        public ApellidoMaterno?: string,
        public CodRelDep?: number,
        public Relacion?: string,
        public FechaNacimiento?: Date,
        public BanderaExclusion?: boolean,
        public BanderaYaExcluido: boolean = false,
        public fechaInclusion?: Date,
    ) { }
}

export class Titulares{
    constructor(
        public NombreTitular?: string,
        public CodigoTitular?: number,
        public Cedula?: string,
        public CodigoCliente?: number,
        public CodigoCiudad?: number,
        public CodigoGrupo?: number,


    ){}
}

export class ListadoString {
    constructor(
        public Nombre?: string) { }
}

export class SiniestroVam {
    constructor(
        public CodigoReclamoAseguradora?: string,
        public CodigoReclamoTecni?: string,
        public Paciente?: string,
        public Diagnostico?: string,
        public ValorPresentado?: number,
        public Deducible?: number,
        public Copago?: number,
        public Indemnizado?: number,
        public FechaPresentacion?: Date,
        public FechaPago?: Date,
        public Prestador?: string,
        public TipoReclamo?: string,
        public EstadoAgrupado?: number,
        public Observacion?: string,
        public CodigoSiniestro?: number,
        public CodigoTracking?: number,
        public Estado?: string,
        public TipoSiniestro?: number,
        public TipoManejo?: number,
        public NumSiniestroAse?: string,
    ) { }
}

export class SiniestrosVamTit {
    constructor(
        public sinPendientes?: SiniestroVam[],
        public sinCerrados?: SiniestroVam[]
    ) { }
}

export class CambiosVam{
    constructor(
        public TitularCambio?: VamTitularEntity,
        public TitularActual?: VamTitularEntity,
        public Poliza?: PolizaEntity,
        public NombrePlan?: string,
        public Cliente?: ClienteLogin,
        public Descripcion?: string
    ){}
}
export class CambiosVamDep{
    constructor(
        public Titular?: VamTitularEntity,
        public Poliza?: PolizaEntity,
        public NombrePlan?: string,
        public Cliente?: ClienteLogin,
        public Descripcion?: string,
        public DependienteCambio?: DependientesVam,
        public DependienteActual?: DependientesVam
    ){}

}

export class TitularVam {
    constructor(
        public CodigoCliente?: number,
        public CodigoCiudad?: number,
        public Cedula?: string,
        public FechaInicio?: string,
        public FechaFin?: string,
        public NombreTitular?: string
    ) { }
}

export class ReclamosLiquidados {
    constructor(
        public NombreAseguradora?: string,
        public NumeroLiquidacion?: string,
        public FechaIncurrencia?: string,
        public ValorPagado?: number,
        public ValorPresentado?: number
    ) { }
}




// WEBPACK FOOTER //
// C:/Fuentes Git/TecnienLineaV2.0/front-consulta-en-linea/src/app/views/vam/titulares/entities/vam_titulares_entity.ts